document.addEventListener( 'DOMContentLoaded', () => {
  const iframe = document.querySelector( '.responsve-iframe' );
  if ( !iframe ) return;

  window.addEventListener( 'message', ( e ) => { // NOSONAR
    iframe.style.height = `${ e.data }px`;
  } );
} );
